import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { ShoppingCartInquiryCheckoutCommandResult, ShoppingCartInquiryDto } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IShoppingCartInquiryApiService {

  abstract shoppingCartInquiryCheckout(shoppingCartInquiry?: ShoppingCartInquiryDto | undefined): Observable<ShoppingCartInquiryCheckoutCommandResult>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IShoppingCartInquiryApiServiceToken = new InjectionToken<IShoppingCartInquiryApiService>('IShoppingCartInquiryApiServiceToken');
